import {onlyItem} from '../../../../../libs/shared/helpers/src/utilities/arrayHelpers';

/*
 * Types.
 */

/** Partially-known selection of items. */
interface InboxesVisualSelection<T> {
  /** Whether the selection is fully-known. */
  readonly isFullyKnown: boolean;
  /** The items that we know are selected. */
  readonly knownIds: ReadonlyArray<T>;
}

/** Partially-known selection of conversations. */
export type InboxesVisualConversationSelection = InboxesVisualSelection<number>;

/** Partially-known selection of messages. */
export type InboxesVisualMessageSelection = InboxesVisualSelection<string>;

/*
 * Constants.
 */

/** We know no items are selected. */
export const emptyVisualSelection: InboxesVisualSelection<any> = Object.freeze({
  isFullyKnown: true,
  knownIds: [],
});

/** We don't know anything about what items are selected. */
export const unknownVisualSelection: InboxesVisualSelection<any> = Object.freeze({
  isFullyKnown: false,
  knownIds: [],
});

/*
 * Factories.
 */

export function createFullyKnownVisualSelection<T>(ids: ReadonlyArray<T>): InboxesVisualSelection<T> {
  return {
    isFullyKnown: true,
    knownIds: ids,
  };
}

/*
 * Helpers.
 */

/** Determines whether no items are selected. */
export function computeIsEmptyVisualSelection(selection: InboxesVisualSelection<unknown>): boolean {
  return selection.isFullyKnown && selection.knownIds.length === 0;
}

export function findOnlyVisuallySelectedId<T>(selection: InboxesVisualSelection<T>): T | undefined {
  return selection.isFullyKnown ? onlyItem(selection.knownIds) : undefined;
}
